module.exports = __webpack_public_path__ + "img/bell_1.790a9f34.jpg";